// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"30a20941","226":"129a3603","229":"032d4ca8","257":"c027ca2c","378":"522af1cd","404":"61a01053","453":"31bf9d75","565":"dc5488d5","599":"f7a91409","773":"5c64cacc","869":"92d384b3"}[chunkId] + ".chunk.js";
};